import { escapeHtml as esc, printHtml } from '../../utils/invoice'
import { brandColors } from '../../data/brandColors'
import { money } from '../../core/format/currency'
import { untilLabel, validForLabel } from './voucherLabels'
import type { MarketingDesign } from '../../core/types/marketing'
import type { Voucher } from '../../core/types/vouchers'

/**
 * De bon om te printen of als PDF te bewaren, met de teksten van het ontwerp "Cadeaubon" uit
 * Marketing (Ontwerpen). Bedrag, code, einddatum en waarvoor hij geldt komen altijd van de bon
 * zelf, nooit uit het ontwerp: daar staat een voorbeeld.
 */
export function voucherHtml(v: Voucher, design: MarketingDesign | undefined, salonName: string): string {
  const eyebrow = design?.eyebrow || 'Cadeaubon'
  const accent = design?.accent ?? ''
  const body = design?.body ?? ''
  return `<!doctype html><html lang="nl"><head><meta charset="utf-8"><title>Cadeaubon ${esc(money(v.initialCents))}</title>
<style>
@page{size:A5 landscape;margin:0}
*{box-sizing:border-box}
body{margin:0;font-family:Inter,system-ui,sans-serif;color:${brandColors.ink};background:${brandColors.sand}}
.card{width:210mm;height:148mm;padding:18mm 20mm;display:flex;flex-direction:column;justify-content:space-between;background:${brandColors.shell}}
.eyebrow{font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:${brandColors.clay}}
h1{font-family:Fraunces,Georgia,serif;font-weight:300;font-size:64px;line-height:1;margin:10px 0 0}
.accent{font-family:Fraunces,Georgia,serif;font-style:italic;color:${brandColors.clay};font-size:22px;margin-top:6px}
.body{max-width:105mm;color:${brandColors.muted};font-size:13px;line-height:1.55;margin-top:14px}
.code{font-family:ui-monospace,Menlo,monospace;font-size:22px;letter-spacing:.08em;padding:10px 14px;border:1px solid ${brandColors.line};display:inline-block;background:#fff}
.meta{display:flex;justify-content:space-between;align-items:flex-end;gap:24px;font-size:12px;color:${brandColors.muted}}
.meta strong{color:${brandColors.ink};font-weight:500}
@media screen{body{padding:24px}}
</style></head><body><div class="card">
<div><div class="eyebrow">${esc(eyebrow)} · ${esc(salonName)}</div>
<h1>${esc(money(v.initialCents))}</h1>
${accent ? `<div class="accent">${esc(accent)}</div>` : ''}
${body ? `<p class="body">${esc(body)}</p>` : ''}</div>
<div class="meta"><div><div style="margin-bottom:6px">Code</div><div class="code">${esc(v.code)}</div></div>
<div style="text-align:right"><strong>${esc(validForLabel[v.validFor])}</strong><br>Geldig tot en met ${esc(untilLabel(v.validUntil))}<br>Deels besteden mag; het restant blijft op de bon.</div></div>
</div></body></html>`
}

export const printVoucher = (v: Voucher, design: MarketingDesign | undefined, salonName: string) =>
  printHtml(voucherHtml(v, design, salonName), `cadeaubon-${v.code.slice(-4)}.html`, 'Cadeaubon')
